import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Utensils } from "lucide-react";
import { api, extractErrorMessage, formatNum } from "@/lib/api";

export default function YearlyRatesPanel({ onChanged }) {
  const [rows, setRows] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/settings/yearly-rates").then((r) => setRows(Object.entries(r.data.rates).map(([y, v]) => ({ yil: y, ...v })))).catch(() => {});
  }, []);
  const set = (i, k, v) => setRows(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const add = () => {
    const last = rows[rows.length - 1];
    setRows([...rows, { yil: String(Number(last?.yil || new Date().getFullYear()) + 1), yemek_gunluk: last?.yemek_gunluk || 0, yol_aylik: last?.yol_aylik || 0 }]);
  };
  const save = async () => {
    setSaving(true);
    try {
      const rates = Object.fromEntries(rows.map((r) => [String(r.yil).trim(), { yemek_gunluk: Number(r.yemek_gunluk) || 0, yol_aylik: Number(r.yol_aylik) || 0 }]));
      await api.put("/settings/yearly-rates", { rates });
      toast.success("Yıllık tutarlar kaydedildi · bordrolar yeniden hesaplanacak");
      onChanged?.();
    } catch (e) { toast.error(extractErrorMessage(e, "Kaydedilemedi")); } finally { setSaving(false); }
  };
  const inp = "px-2 py-1.5 border border-slate-200 rounded-md text-sm font-mono-tab text-right w-full";

  return (
    <div className="bg-slate-50 border border-slate-200 rounded-lg p-4" data-testid="yearly-rates-panel">
      <div className="flex items-center gap-2 mb-1"><Utensils size={16} className="text-teal-700" /><h4 className="font-semibold text-sm">Yıllık Yemek & Yol Tutarları</h4></div>
      <p className="text-xs text-slate-600 mb-3">Kişiye veya pozisyona özel tutar girilmemişse bordroya otomatik gelir. Günlük yol = aylık yol ÷ 30. Bordroda her ay elle de değiştirilebilir.</p>
      <table className="w-full text-xs">
        <thead><tr className="text-slate-500"><th className="text-left pb-1 w-20">Yıl</th><th className="text-right pb-1">Günlük Yemek (₺)</th><th className="text-right pb-1">Aylık Yol (₺)</th><th className="text-right pb-1">Günlük Yol (₺)</th><th /></tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} data-testid={`yearly-rate-row-${r.yil}`}>
              <td className="pr-2 py-1"><input className={inp} value={r.yil} onChange={(e) => set(i, "yil", e.target.value)} data-testid={`yearly-rate-yil-${i}`} /></td>
              <td className="px-1 py-1"><input type="number" step="0.01" className={inp} value={r.yemek_gunluk} onChange={(e) => set(i, "yemek_gunluk", e.target.value)} data-testid={`yearly-rate-yemek-${i}`} /></td>
              <td className="px-1 py-1"><input type="number" step="0.01" className={inp} value={r.yol_aylik} onChange={(e) => set(i, "yol_aylik", e.target.value)} data-testid={`yearly-rate-yol-${i}`} /></td>
              <td className="px-1 py-1 text-right font-mono-tab text-slate-700" data-testid={`yearly-rate-yol-gunluk-${i}`}>{formatNum((Number(r.yol_aylik) || 0) / 30)}</td>
              <td className="pl-1"><button type="button" onClick={() => setRows(rows.filter((_, j) => j !== i))} className="p-1 text-rose-600 hover:bg-rose-50 rounded"><Trash2 size={12} /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-between mt-2">
        <button type="button" onClick={add} data-testid="yearly-rate-add" className="inline-flex items-center gap-1 text-xs font-semibold text-slate-700 px-2 py-1 border border-slate-300 rounded-md bg-white"><Plus size={12} /> Yıl Ekle</button>
        <button type="button" onClick={save} disabled={saving} data-testid="yearly-rate-save" className="px-3 py-1.5 bg-teal-700 hover:bg-teal-800 text-white rounded-md text-xs font-semibold disabled:opacity-50">{saving ? "Kaydediliyor..." : "Tutarları Kaydet"}</button>
      </div>
    </div>
  );
}
